/** @jsx h */
import { h } from 'preact'
import { useState } from 'preact/hooks'

import HelpIcon from '../icons/HelpIcon'
import t from '../../../utils/translate'

const HelpButton = ({ toggle }) => {
  const [isFocused, setIsFocused] = useState(false)

  const handleMouseDown = e => {
    if (e.currentTarget === document.activeElement) {
      document.activeElement.blur()
      e.preventDefault()
    }

    toggle()
  }

  const handleClick = e => {
    // Firefox and Safari on macOS and iOS buttons don't receive focus
    // See: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
    if (
      /apple/i.test(navigator.vendor) ||
      /Mac.*Firefox/.test(navigator.userAgent)
    ) {
      if (isFocused) {
        document.activeElement.blur()
      } else {
        e.currentTarget.focus()
      }
      setIsFocused(!isFocused)
    }
  }

  return (
    <button
      type='button'
      class='Action--circle JourneyHelp JourneyTip'
      onMouseDown={handleMouseDown}
      onClick={handleClick}
    >
      <HelpIcon />
      <div class='JourneyTip-content'>
        <h2 class='BodyUI--emphasis'>{t('journeys.js.value_tip.title')}</h2>
        <br />
        <p class='CaptionUI--regular'>
          {t('journeys.js.value_tip.description')}
        </p>
      </div>
    </button>
  )
}

export default HelpButton
